import React from 'react';
import CardFeature from './CardFeature';
import cafImg from '../assets/caf.png';
import patronatoImg from '../assets/patronato.png';
import immigrazioneImg from '../assets/immigrazione.png';
import serviziImg from '../assets/servizi.png';

const Cards = () => {
  const cardData = [
    {
      image: cafImg,
      title: 'CAF',
      description:
        'Fornisce servizi fiscali come dichiarazioni dei redditi, ISEE e prestazioni familiari.',
    },
    {
      image: patronatoImg,
      title: 'PATRONATO',
      description:
        'Offre supporto gratuito per previdenza sociale, pensioni, disabilità e assistenza legale.',
    },
    {
      image: immigrazioneImg,
      title: 'IMMIGRAZIONE',
      description:
        'Assiste con permessi di soggiorno, cittadinanza, ricongiungimenti familiari e supporto agli immigrati.',
    },
    {
      image: serviziImg,
      title: 'ALTRI SERVIZI',
      description:
        'Copre servizi aggiuntivi come assistenza abitativa, bonus e certificazioni.',
    },
  ];


  return (
    <section className="-mt-16 md:-mt-24 relative z-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {cardData.map((card, index) => (
          <CardFeature
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default Cards;
